import $ from "jquery";
import Swiper from "swiper/bundle";

/* Slider logos */

const sliders = document.querySelectorAll(".js-slider .swiper");

sliders.forEach((sliderElement) => {
	const swiperInstance = new Swiper(sliderElement, {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 30,
		speed: 800, // Aangepaste snelheid voor een soepelere overgang
		effect: "slide", // Effect blijft 'slide' voor soepelere overgangen
		mousewheel: {
			enabled: true, // Inschakelen van muiswielnavigatie
		},
		navigation: {
			nextEl: sliderElement.querySelector(".swiper-button-next"),
			prevEl: sliderElement.querySelector(".swiper-button-prev"),
		},
		breakpoints: {
			468: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 3,
			},
			1025: {
				slidesPerView: 4,
			},
		},
	});
});

/* Slider three elements */

$(".js-slider-three-elements").each(function () {
	const slides = $(this).find(".slider__slide").length;
	if (slides <= 3) {
		$(this).addClass("no-navigation");
	} else {
		$(this).removeClass("no-navigation");
	}
});

const swiperThreeElements = document.querySelectorAll(
	".js-slider-three-elements .swiper",
);

swiperThreeElements.forEach((slider) => {
	slider = new Swiper(slider, {
		slidesPerView: 1,
		spaceBetween: 32,
		watchOverflow: true,
		navigation: {
			nextEl: slider.querySelector(".swiper-button-next-v2"),
			prevEl: slider.querySelector(".swiper-button-prev-v2"),
		},
		breakpoints: {
			900: {
				slidesPerView: 2,
			},
			1280: {
				slidesPerView: 3,
			},
		},
	});
});

/* Slider four elements */

$(".js-slider-four-elements").each(function () {
	const slides = $(this).find(".slider__slide").length;
	if (slides <= 4) {
		$(this).addClass("no-navigation");
	} else {
		$(this).removeClass("no-navigation");
	}
});

const swiperFourElements = document.querySelectorAll(
	".js-slider-four-elements .swiper",
);

swiperFourElements.forEach((slider) => {
	slider = new Swiper(slider, {
		slidesPerView: 1,
		spaceBetween: 32,
		watchOverflow: true,
		navigation: {
			nextEl: slider.querySelector(".swiper-button-next-v2"),
			prevEl: slider.querySelector(".swiper-button-prev-v2"),
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			900: {
				slidesPerView: 3,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 24,
			},
		},
	});
});

/* Slider techwiki items */

$(".js-slider-techwiki-items").each(function () {
	const slides = $(this).find(".slider-techwiki-items__slide").length;
	if (slides <= 5) {
		$(this).addClass("no-navigation");
	} else {
		$(this).removeClass("no-navigation");
	}
});

const swiperTechwikiItems = document.querySelectorAll(
	".js-slider-techwiki-items .swiper",
);

swiperTechwikiItems.forEach((slider) => {
	slider = new Swiper(slider, {
		slidesPerView: 1,
		spaceBetween: 32,
		watchOverflow: true,
		navigation: {
			nextEl: slider.querySelector(".swiper-button-next-v2"),
			prevEl: slider.querySelector(".swiper-button-prev-v2"),
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			900: {
				slidesPerView: 3,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 24,
			},
		},
	});
});

/* Slider full width */

const swiperFullwidth = document.querySelectorAll(
	".js-slider-full-width .swiper",
);

swiperFullwidth.forEach((slider) => {
	slider = new Swiper(slider, {
		slidesPerView: 1,
		spaceBetween: 40,
		navigation: {
			nextEl: slider.querySelector(".swiper-button-next-v2"),
			prevEl: slider.querySelector(".swiper-button-prev-v2"),
		},
	});
});
